module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-white content-padded",
    attrs: {
      "onload": "init()"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "第三方名称"
    }
  }, [_c('div', [_c('el-select', {
    attrs: {
      "placeholder": "第三方名称"
    },
    model: {
      value: (_vm.third_name),
      callback: function($$v) {
        _vm.third_name = $$v
      },
      expression: "third_name"
    }
  }, _vm._l((_vm.thirdnamelist), function(third_name) {
    return _c('el-option', {
      key: third_name.value,
      attrs: {
        "label": third_name.label,
        "value": third_name.value,
        "disabled": third_name.disabled
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权益名称"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "权益名称"
    },
    model: {
      value: (_vm.form.type_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "type_name", $$v)
      },
      expression: "form.type_name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权益类型"
    }
  }, [_c('div', [_c('el-select', {
    attrs: {
      "placeholder": "权益类型"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, _vm._l((_vm.typelist), function(type) {
    return _c('el-option', {
      key: type.value,
      attrs: {
        "label": type.label,
        "value": type.value,
        "disabled": type.disabled
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "权益描述"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.type_desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "type_desc", $$v)
      },
      expression: "form.type_desc"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "额外参数"
    }
  }, [_c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.type_param),
      callback: function($$v) {
        _vm.$set(_vm.form, "type_param", $$v)
      },
      expression: "form.type_param"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "size": "large"
    },
    on: {
      "click": _vm.backCancle
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.submitItemsActionConfirm
    }
  }, [_vm._v(_vm._s(_vm.submitLoading ? '提交中' : '保存'))])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2302721e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2302721e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/thirds/setting/thirdsseting_editor.vue
// module id = 2537
// module chunks = 0